import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=19232ebd&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=19232ebd&prod&lang=scss&scoped=true"
import style1 from "./DetailView.vue?vue&type=style&index=1&id=19232ebd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19232ebd",
  null
  
)

export default component.exports